import { defineComponent, getCurrentInstance } from 'vue';
import { Empty } from '@cfx/base-mobile';

export default defineComponent({
  name: 'MkNoStatus',
  props: {
    description: {
      type: String,
      default: '找不到素材了'
    },
    type: {
      type: String as any,
      default: 'error_file'
    },
    isShowReTurnBar: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { slots }) {
    const globalProperties = getCurrentInstance()?.appContext?.config?.globalProperties as Record<string, any>;
    return () => (
      <div class="flex-c" style="height: 100%; flex-direction: column;">
        {(globalProperties.$urlObj.showGoBackBtn === 'true' && props.isShowReTurnBar) ? <mk-return-bar /> : ''}
        <div class="flex-c flex-1">
          <Empty { ...props } v-slots={{ default: () => <span> </span>, ...slots }} type={props.type}></Empty>
        </div>
      </div>
    );
  }
});
